export default __webpack_public_path__ + "static/media/bundle-guide-me-us-white@2x.9b6d58ad.webp";